import Vue from 'vue';
import Vuex from 'vuex';
import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import { user } from './user';
import { oidcSettings } from '@/settings/oidcSettings';
import { mstoreSettings } from '@/settings/mstoreSettings';
import { documentView } from './documentView';
import { relatedDocuments } from './relatedDocuments';
import { list } from './list';
import { workflowJob } from './workflowJob';
import { workflowQueue } from './workflowQueue';
import { userPreferences } from './userPreferences';
import createPersistedState from 'vuex-persistedstate';
import { automotiveWorklowJob } from './automotiveWorklowJob';
import { mTable } from './mtable';
import { docuSignWorklowJob } from './docuSignWorkflowJob';
import { scriveWorklowJob } from './scriveWorkflowJob';
import { applicationDirty } from './applicationDirty';
import { workflowKanbanJob } from './workflowKanbanJob';
import { documentToStore } from './documentToStore';
import { thumbnails } from './thumbnails';
import { configuration } from './configuration';
import { cabinetConfiguration } from './configuration/cabinetConfiguration';
import { editReferences } from './editReferences';
import { configurationChange } from './configuration/configurationChange';
import { StoreConstants } from '@/types';
import { listMaintenance } from './configuration/listMaintenance';
import { search } from './search';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    oidcStore: vuexOidcCreateStoreModule(
      oidcSettings,
      {
        namespaced: true,
        dispatchEventsOnWindow: true
      },
      {
        userSignedOut: () => store.dispatch('oidcStore/authenticateOidc'),
        accessTokenExpired: () => store.dispatch('oidcStore/signOutOidc'),
        userLoaded: (user: any) => store.dispatch('userStore/updateCurrentUser', user)
      }
    ),
    userStore: user as any,
    documentViewStore: documentView as any,
    mstoreSettingsStore: mstoreSettings as any,
    relatedDocumentsStore: relatedDocuments as any,
    workflowJobStore: workflowJob as any,
    listStore: list as any,
    workflowQueueStore: workflowQueue as any,
    userPreferencesStore: userPreferences as any,
    automotiveWorkflowJobStore: automotiveWorklowJob as any,
    mTableStore: mTable as any,
    docuSignWorkflowJobStore: docuSignWorklowJob as any,
    scriveWorkflowJobStore: scriveWorklowJob as any,
    applicationDirtyStore: applicationDirty as any,
    workflowKanbanJobStore: workflowKanbanJob as any,
    documentToStoreStore: documentToStore as any,
    thumbnailStore: thumbnails as any,
    [StoreConstants.Configuration.ModuleName]: configuration as any,
    [StoreConstants.CabinetConfiguration.ModuleName]: cabinetConfiguration as any,
    editReferencesStore: editReferences as any,
    [StoreConstants.ConfigurationChange.ModuleName]: configurationChange,
    [StoreConstants.ListMaintenance.ModuleName]: listMaintenance,
    [StoreConstants.Search.ModuleName]: search
  },
  plugins: [
    createPersistedState({
      paths: ['userPreferencesStore']
    }),
    createPersistedState({ paths: ['workflowQueueStore', StoreConstants.Search.ModuleName], storage: sessionStorage })
  ]
});

export default store;
